var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row",
      class: { "proprietaire-highlight": _vm.proprietaire.Highlight }
    },
    [
      _c(
        "div",
        { staticClass: "col-2 text-right pr-0" },
        [
          _vm.proprietaire.NumeroPersonne
            ? [
                _c(
                  "span",
                  {
                    staticClass: "badge badge-info",
                    attrs: {
                      title: "Identifiant de la personne dans le cadastre"
                    }
                  },
                  [_vm._v(_vm._s(_vm.proprietaire.NumeroPersonne))]
                ),
                _vm._v(" "),
                !_vm.proprietaire.References
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary px-1",
                        attrs: {
                          type: "button",
                          title:
                            "Modifier les informations, aura pour effet de le détacher du cadastre"
                        },
                        on: { click: _vm.edit }
                      },
                      [_c("i", { staticClass: "fa fa-fw fa-edit" })]
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-danger px-1",
              attrs: { type: "button" },
              on: { click: _vm.remove }
            },
            [_c("i", { staticClass: "fa fa-fw fa-minus" })]
          ),
          _vm._v(" "),
          _vm.proprietaire.NumeroPersonne &&
          !_vm.proprietaire.References &&
          _vm.getSamePersonneProprietaire(_vm.proprietaire)
            ? [
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "alert alert-info p-1 mt-1 d-inline-block",
                    attrs: {
                      title:
                        "Ce propriétaire semble être la même personne que sur une autre parcelle."
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-warning float-left m-1" }),
                    _vm._v(" Lier ce propriétaire à "),
                    _c("em", [_vm._v(_vm._s(_vm.proprietaire.NumeroPersonne))]),
                    _vm._v(" ?\n                "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.linkProprietaire(_vm.proprietaire)
                          }
                        }
                      },
                      [_vm._v("Oui")]
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-10" },
        [
          _vm.proprietaire.References
            ? [
                _c("CopieProprietaire", {
                  attrs: {
                    "referenced-proprietaire": _vm.getReferencedProprietaire(
                      _vm.proprietaire.References
                    )
                  },
                  model: {
                    value: _vm.proprietaire,
                    callback: function($$v) {
                      _vm.proprietaire = $$v
                    },
                    expression: "proprietaire"
                  }
                })
              ]
            : [
                _c("Acteur", {
                  attrs: {
                    "is-proprietaire": true,
                    readonly: _vm.proprietaire.NumeroPersonne != null
                  },
                  model: {
                    value: _vm.proprietaire,
                    callback: function($$v) {
                      _vm.proprietaire = $$v
                    },
                    expression: "proprietaire"
                  }
                })
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06c751c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c751c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/Proprietaire.vue
// module id = 662
// module chunks = 0